import {
  LineItemAdapter,
  BundleCartItemWithProduct,
} from '@storefront/adapters/LineItemAdapter';
import { LineItem } from '@storefront/data-commerce';
import { HeldError } from '@storefront/shared-components/error-information/held-error';

export const toLineItems = (items: BundleCartItemWithProduct[]): LineItem[] => {
  let lineItems: LineItem[] = [];
  try {
    const lineItemAdapter = new LineItemAdapter(items);
    lineItems = lineItemAdapter.toLineItems();
  } catch (error) {
    console.error('Error converting cart items to line items', error);
    throw new HeldError('errors.CANNOT_ACCESS_CART');
  }

  return lineItems?.map((lineItem) => ({
    quantity: lineItem.quantity ?? null,
    price: lineItem.price ?? null,
    __typename: 'LineItem',
    features: lineItem.features ?? null,
    label: lineItem.label ?? null,
    name: lineItem.name ?? null,
    sku: lineItem.sku ?? null,
    thumbnail: lineItem.thumbnail ?? null,
    title: lineItem.title ?? null,
  }));
};

export const defaultIncludedPrinterFeatures = (contractMonths: number) => [
  {
    order: 9,
    title: 'includedPrinterFeatures.continuousCoverage',
  },
  {
    order: 10,
    title: 'includedPrinterFeatures.nextBusinessDayReplacement',
  },
  {
    order: 20,
    title: 'includedPrinterFeatures.upgradeEligibility',
    contractMonths: contractMonths,
  },
  {
    order: 30,
    title: 'includedPrinterFeatures.24per7ProLiveSupport',
  },
];
